import { render, staticRenderFns } from "./ClassroomSelectbox.vue?vue&type=template&id=7976f383"
import script from "./ClassroomSelectbox.vue?vue&type=script&lang=js"
export * from "./ClassroomSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports